<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.coach.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.coach.list.title"></app-i18n>
      </h1>

      <app-coach-list-toolbar></app-coach-list-toolbar>
      <app-coach-list-filter></app-coach-list-filter>
      <app-coach-list-table></app-coach-list-table>
    </div>
  </div>
</template>

<script>
import CoachListFilter from '@modules/coach/components/coach-list-filter.vue';
import CoachListTable from '@modules/coach/components/coach-list-table.vue';
import CoachListToolbar from '@modules/coach/components/coach-list-toolbar.vue';

export default {
  name: 'app-coach-list-page',

  components: {
    [CoachListFilter.name]: CoachListFilter,
    [CoachListTable.name]: CoachListTable,
    [CoachListToolbar.name]: CoachListToolbar,
  },
};
</script>

<style>
</style>
